//utils
import { config } from './config'
import {
  logThis,
  hasClass,
  addRemoveClasses
} from './utils'

const formIscrizione = () => {
  if (config.debug) logThis("init formIscrizione");
  const planInputEl = document.getElementById("plan");
  const selectDetailsEl = document.getElementById("select-details");
  const messageEl = document.getElementById("message");
  const details = [
    {
      id: "spin",
      label: "SPIN!",
      plans: ["Basic 4i", "Essential 4i", "Pass 4i"]
    },
    {
      id: "cartoome",
      label: "CARTOOME",
      plans: ["Basic 4i", "Essential 4i", "Pass 4i"]
    },
    {
      id: "corpi-parlanti",
      label: "CORPI PARLANTI",
      plans: ["Basic 4i", "Essential 4i", "Pass 4i"]
    },
    {
      id: "trainme",
      label: "TRAINME",
      plans: ["Basic 4i", "Essential 4i", "Pass 4i"]
    },
    {
      id: "talesme",
      label: "TALESME",
      labelDisabled: "TALESME | disponibile dal piano Essential 4i",
      plans: ["Essential 4i", "Pass 4i"]
    },
    {
      id: "senza-senso",
      label: "SENZA SENSO",
      labelDisabled: "SENZA SENSO | disponibile dal piano Essential 4i",
      plans: ["Essential 4i", "Pass 4i"]
    },
    {
      id: "memory",
      label: "MEMORY",
      labelDisabled: "MEMORY | disponibile dal piano Essential 4i",
      plans: ["Essential 4i", "Pass 4i"]
    },
    {
      id: "learnme",
      label: "LEARNME",
      labelDisabled: "LEARNME | disponibile dal piano Essential 4i",
      plans: ["Essential 4i", "Pass 4i"]
    },
    {
      id: "all-tech",
      label: "ACCESSO A TUTTE LE TECNOLGIE DI SPAZI 4i",
      labelDisabled: "ACCESSO A TUTTE LE TECNOLGIE DI SPAZI 4i | disponibile dal piano Pass 4i",
      plans: ["Pass 4i"]
    },
  ]
  details.forEach((detail) => {
    detail.el = document.getElementById(detail.id);
    detail.elGroup = document.getElementById(detail.id + "-check");
    detail.elLabel = document.getElementById(detail.id + "-label");
  })
  const handlePlanInputChange = (event) => {
    const plan = event.target.value;
    details.forEach((detail) => {
      if (detail.plans.includes(plan)) {
        detail.el.disabled = false;
        console.log(detail.elLabel.innerHTML);
        addRemoveClasses(detail.elGroup, ['opacity-100'], 'add');
        addRemoveClasses(detail.el, ['cursor-pointer'], 'add');
        addRemoveClasses(detail.elLabel, ['cursor-pointer'], 'add');
        addRemoveClasses(detail.elGroup, ['opacity-50'], 'remove');
        detail.elLabel.innerHTML = detail.label;
      } else {
        detail.el.disabled = true;
        detail.el.checked = false;
        detail.elLabel.innerHTML = detail.labelDisabled;
        addRemoveClasses(detail.elGroup, ['opacity-100'], 'remove');
        addRemoveClasses(detail.el, ['cursor-pointer'], 'remove');
        addRemoveClasses(detail.elLabel, ['cursor-pointer'], 'remove');
        addRemoveClasses(detail.elGroup, ['opacity-50'], 'add');
      }
    })
    if (plan == "Mind 4i") {
      addRemoveClasses(selectDetailsEl, ['hidden'], 'add');
      messageEl.placeholder = "Raccontaci la tua idea, di cosa hai bisogno, qual è il tuo progetto"
    } else {
      addRemoveClasses(selectDetailsEl, ['hidden'], 'remove');
      messageEl.placeholder = "Se hai domande o richieste particolare non esitare a chiedere. Se lo desideri, indica la fascia oraria in cui preferisci essere contattato."
    }
  }
  planInputEl.addEventListener("change", handlePlanInputChange);

}

export default formIscrizione;
